module.exports = __webpack_public_path__ + "static/media/brasao-pgm.03d66627.png";